// extracted by mini-css-extract-plugin
module.exports = {"aboutAuthor":"NEbqS","info":"inOWg","details":"oYz1q"};